import cx from 'classnames';

import { Heading } from 'components/Heading';

import {
  ContactFormState,
  useContactPage,
} from 'hooks/page/contact/useContactPage';

import s from './OrganicContact.module.css';

const OrganicContact = () => {
  const { formTitle, formState, onSubmit, renderFormElements } = useContactPage(
    {
      styles: {
        textarea: s.formTextArea,
        button: s.sendButton,
        error: s.error,
        subtitle: s.formSubTitle,
        input: s.formInput,
        recaptchaDisclaimer: s.recaptchaDisclaimer,
      },
    },
  );

  const ContactFormSent = () => (
    <div>
      <div className={cx(s.formTitle, s.bigTitle)}>
        Your message has been sent!
      </div>
    </div>
  );

  const ContactFormError = () => (
    <div>
      <div className={cx(s.formTitle, s.bigTitle)}>
        Error sending your message. Please try again later.
      </div>
    </div>
  );

  const renderContent = () => {
    switch (formState) {
      case ContactFormState.SENT:
        return <ContactFormSent />;
      case ContactFormState.ERROR:
        return <ContactFormError />;
      default:
        return (
          <form onSubmit={onSubmit} className={s.form} noValidate>
            {renderFormElements()}
          </form>
        );
    }
  };

  const renderTitle = () => {
    if (formState === ContactFormState.DEFAULT) {
      return (
        <Heading as="h1" className={s.title}>
          {formTitle}
        </Heading>
      );
    }

    return null;
  };

  return (
    <div className={s.root}>
      {renderTitle()}
      <div className={s.wrapper}>{renderContent()}</div>
    </div>
  );
};

export { OrganicContact };
